
import ArrowBackIcon from '@material-ui/icons/ArrowBack'


import PortalModal, { usePortalModal } from 'components/commons/PortalModal'

import homeIcon from 'images/components/reporter/HomeIcon.svg'

import previewQuestionnaireStyles from './styles'
import Imagem from './assets/image/Enthusiastic-cuate.png'
import {
   Button,
   Paper,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'

function MediumQues({ score }) {
   const classes = previewQuestionnaireStyles()
   const history = useHistory()

 const handlePrev = () => {  
   history.push('/dashboard/mutual-world?show=true')
}
 const goToMundoBack = () => {
  history.push('/dashboard/mutual-world?show=true')
}
  return (
     <div className={classes.container}>
        <Paper className={classes.paper}>
        <div className={classes.boxLineDecoration}>
               <div style={{ backgroundColor: '#71BE4A', width: '10%' }} />
               <div style={{ backgroundColor: '#0098DF', width: '10%' }} />
            </div>
            <h2 style={{marginTop: '40px'}} className={classes.titleResults}>¡Felicitaciones!</h2>
            <p  className={classes.subtitleResults}>TUS PUNTOS</p>
            <h2  className={classes.titleResults}>{score.score}</h2>
            <img className={classes.imgResults} src={Imagem} />
            <p className={classes.textResults}>Has finalizado con éxito el aprendizaje de <span className={classes.textResultsSpan}>{score.funtionality.name}</span> </p>
            <p className={classes.subtextResults}>Ya cuentas con un certificado disponible. Para visualizar y descargar haz clic en el botón volver y luego en el botón ver certificado.</p>
            <Button
               className={classes.buttonReadyAnswer}
               size="large"
               variant="contained"
               color="primary"
               style={{marginBottom: '40px'}}
               onClick={() => goToMundoBack()}

               >
                  VOLVER
            </Button>
        </Paper>
     </div>
  )
}

export default MediumQues
